import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { MdHelp, MdEmail } from 'react-icons/md';
import ContactForm from '../components/ContactForm';

function HelpSupportPage() {
  const { user } = useAuth();

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      {/* Header */}
      <div className="text-center mb-8">
        <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
          <MdHelp className="text-4xl text-primary" />
        </div>
        <h1 className="text-3xl font-bold text-white font-rubik" data-testid="help-page-title">Help & Support</h1>
        <p className="text-gray-300 mt-2 font-rubik">Have a question or need assistance? Fill out the form below and we'll get back to you.</p>
      </div>

      {/* Contact Form */}
      <div className="card-container">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 bg-secondary/10 rounded-lg flex items-center justify-center">
            <MdEmail className="text-xl text-secondary" />
          </div>
          <div>
            <h2 className="text-xl font-bold text-gray-800 font-rubik">Contact Us</h2>
            <p className="text-sm text-gray-600 font-rubik">Send us a message and we&apos;ll get back to you</p>
          </div>
        </div>

        <ContactForm variant="light" userId={user?.userId || null} />
      </div>

      {/* Footer Links */}
      <div className="mt-8 text-center">
        <p className="text-gray-500 font-rubik text-xs">
          <Link to="/privacy" className="text-gray-400 hover:text-primary transition-colors" data-testid="privacy-link">Privacy Policy</Link>
          <span className="mx-2">|</span>
          <Link to="/terms" className="text-gray-400 hover:text-primary transition-colors" data-testid="terms-link">Terms & Conditions</Link>
        </p>
      </div>
    </div>
  );
}

export default HelpSupportPage;
